export function state() {
	return {
		roles: null,
		userProfile: {},
		formulateUserProfile: null,
		personalLandings: null,
		personalRecommendations: [],
		tagsRecommendations: [],
	};
}

export const mutations = {
	setRoles(state, roles) {
		state.roles = roles;
	},
	setProfile(state, profile) {
		state.userProfile = profile;
	},
	setFieldOfProfile(state, obj) {
		state.userProfile[obj.slug] = obj.value;
	},
	setFormulateUserProfile(state, profile) {
		state.formulateUserProfile = profile;
	},
	setPersonalLandings(state, data) {
		state.personalLandings = data;
	},
	setPersonalRecommendations(state, data) {
		state.personalRecommendations = data;
	},
	setTagsRecommendations(state, data) {
		state.tagsRecommendations = data;
	},
};

export const getters = {
	isAlumni: (state) => {
		if (state.roles) {
			return state.roles.includes('alumni');
		}

		return false;
	},
	isPersonalLandings: (state) => state.personalLandings !== null,
	isPersonalRecommendations: (state) => state.personalRecommendations?.length > 0,
	personalRecommendations: (state) => state.personalRecommendations,
	tagsRecommendations: (state) => state.tagsRecommendations,
};

let getRolesPromise = null;
let getUserProfilePromise = null;
let getUserFormulateProfilePromise = null;

export const actions = {
	async getRoles({ state, commit }) {
		if (!this.$auth.loggedIn || state.roles) {
			return state.roles;
		}

		if (!getRolesPromise) {
			getRolesPromise = this.$api.axios.$get('/api/v2/user/roles');
			const roles = await getRolesPromise;

			commit('setRoles', roles);

			return roles;
		}

		return getRolesPromise;
	},
	async getProfile({ state, commit }) {
		if (!this.$auth.loggedIn) {
			return null;
		}

		if (!getUserProfilePromise) {
			getUserProfilePromise = this.$api.getUserProfile()
				.catch((error) => {
					// If user is not authenticated, return null instead of throwing
					if (error.response && error.response.status === 401) {
						console.warn('User not authenticated in store/profile.js');
						return null;
					}
					throw error;
				});
		}

		const profile = await getUserProfilePromise;

		if (profile) {
			commit('setProfile', profile);
		}

		return profile;
	},
	async getFormulateProfile({ state, commit }) {
		if (!getUserFormulateProfilePromise) {
			getUserFormulateProfilePromise = this.$api.getFormulateProfile();
		}

		if (this.$auth.loggedIn
			&& !state.formulateUserProfile
		) {
			const profile = await getUserFormulateProfilePromise;

			commit('setFormulateUserProfile', profile);

			return profile;
		}

		return state.formulateUserProfile;
	},
	async getPersonalLandings({ commit }) {
		const landings = await this.$pagesApi.getPersonalLandings();
		let landingsList = landings?.data?.data || [];
		const recomm = {};
		landingsList.userRecommendations?.forEach((el) => {
			if (recomm[el.manager_category] === undefined) {
				recomm[el.manager_category] = [];
			}
			recomm[el.manager_category].push(el);
		});
		if (Object.keys(recomm).length > 0) {
			landingsList.userRecommendations = recomm;
		} else {
			landingsList = null;
		}

		commit('setPersonalLandings', landingsList);
	},
	async getPersonalRecommendations({ commit }) {
		const { data: values } = await this.$api.getUserProfileFields('slugs[]=user_recommendations');
		let tags = [];

		if (values.user_recommendations && Array.isArray(values.user_recommendations)) {
			tags = values.user_recommendations.map((el) => +el);
		} else if (values.user_recommendations) {
			console.warn('user_recommendations is not an array:', values.user_recommendations);
			if (typeof values.user_recommendations === 'string') {
				try {
					const parsed = JSON.parse(values.user_recommendations);
					if (Array.isArray(parsed)) {
						tags = parsed.map((el) => +el);
					}
				} catch (e) {
					tags = [+values.user_recommendations];
				}
			} else {
				tags = [];
			}
		}
		commit('setPersonalRecommendations', tags);
	},
	async getTagsRecommendations({ commit }) {
		try {
			const { data } = await this.$api.getTagsRecommendations();
			commit('setTagsRecommendations', data);
		} catch (error) {
			console.error('Error fetching tags recommendations:', error);
		}
	},
};
